<template>
	<div>
		<v-dialog v-model="dialog_roundoff" no-click-animation persistent lazy full-width width="290px" transition="dialog-bottom-transition">
        	<v-card>
        	  	<v-card-text>
        	  		<v-form data-vv-scope="field">
        	  			<v-layout row wrap>

        	  				<v-flex xs12 sm12 md12>
					           	<v-radio-group v-model="roundOffNature" row>
							    	<v-radio label="Add" :value="1"></v-radio>
							      	<v-radio label="Subtract" :value="0"></v-radio>
							    </v-radio-group>
					        </v-flex>

	        	  			<v-flex xs12 sm12 md12>
        	  					<v-text-field
		        	  			  	label="Round Off Value"
		        	  			  	placeholder=" "
		        	  			  	type="number"
		        	  			  	v-model.number="roundOffValue"
		        	  			  	v-validate="'required|decimal:2'"
				               		data-vv-name="roundoff"
				               		data-vv-as="round off"
				               		:error-messages="errors.collect('field.roundoff')" 
		        	  			></v-text-field>
		        	  			</v-flex>
        	  			</v-layout>
        	  		</v-form>
        	  	</v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog">close</v-btn>
		          <v-btn color="blue darken-1" flat @click.native="fn_checkValidations">done</v-btn>
		        </v-card-actions>
	        </v-card>	
      	</v-dialog>
	</div>
</template>

<script>
export default{
	data(){	
		return{
			dialog_roundoff: false,
			roundOffValue:null,
			roundOffNature:null
		}
	},
	methods:{
		openDialogWeb: function () {
			this.errors.clear('fields');
			this.roundOffNature = this.$parent.Form.roundOffValue < 0 ? 0 : 1;
			this.roundOffValue = Math.abs(this.$parent.Form.roundOffValue);
			this.dialog_roundoff = true;
		},
		closeDialogWeb: function () {
			this.dialog_roundoff = false;
		},
		fn_checkValidations: function () {
			this.$validator.validateAll('fields').then((result) => {
				if(result){
					this.$parent.fn_setRoundOffValue(this.roundOffValue, this.roundOffNature)
				}
		    });
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_roundoff.vue